

class BaseWorker
{

    constructor (name,id)
    {
        this.name = name;
        this.posY = 0;
        this.posY = 0;
        this.id = id;
        this.language = "en";
        this.title="unknow";
        this.status = -2; // pas a faire
        this.error = "";
        this.pc = 0;
        this.pid = 0;
        this.repeat=0;

    }

    getStatus()
    {
        return this.status;
    }

    setStatus(status)
    {
        this.status = status;
    }

    setLanguage(language)
    {
        this.language = language;
    }

    getId()
    {
        return this.id;
    }
    getName()
    {
        return this.name;
    }

    getSize ()
    {
        return {width:200, height:150};
    }

    setPosY(posy)
    {
        this.posY = posy;   // 
    }

    setPosX(posx)
    {
        this.posX = posx;   // 
    }

    getPosX()
    {
        return this.posX;
    }

    getPosY()
    {
        return this.posY;
    }

    setVideo(datas)
    {
        this.video = datas;
    }

    dessinerRectangleArrondi(ctx, x, y, largeur, hauteur, rayon, couleurRemplissage, couleurBordure, epaisseurBordure) {
        ctx.beginPath();
        ctx.moveTo(x + rayon, y);
        ctx.lineTo(x + largeur - rayon, y);
        ctx.quadraticCurveTo(x + largeur, y, x + largeur, y + rayon);
        ctx.lineTo(x + largeur, y + hauteur - rayon);
        ctx.quadraticCurveTo(x + largeur, y + hauteur, x + largeur - rayon, y + hauteur);
        ctx.lineTo(x + rayon, y + hauteur);
        ctx.quadraticCurveTo(x, y + hauteur, x, y + hauteur - rayon);
        ctx.lineTo(x, y + rayon);
        ctx.quadraticCurveTo(x, y, x + rayon, y);
        ctx.closePath();
    
        // Remplissage
        ctx.fillStyle = couleurRemplissage;
        ctx.fill();
    
        // Bordure
        ctx.lineWidth = epaisseurBordure;
        ctx.strokeStyle = couleurBordure;
        ctx.stroke();
    }
    
    dessinerRectangleArrondiSansBordure(ctx, x, y, largeur, hauteur, rayon, couleurRemplissage) {
        ctx.beginPath();
        ctx.moveTo(x + rayon, y);
        ctx.lineTo(x + largeur - rayon, y);
        ctx.quadraticCurveTo(x + largeur, y, x + largeur, y + rayon);
        ctx.lineTo(x + largeur, y + hauteur - rayon);
        ctx.quadraticCurveTo(x + largeur, y + hauteur, x + largeur - rayon, y + hauteur);
        ctx.lineTo(x + rayon, y + hauteur);
        ctx.quadraticCurveTo(x, y + hauteur, x, y + hauteur - rayon);
        ctx.lineTo(x, y + rayon);
        ctx.quadraticCurveTo(x, y, x + rayon, y);
        ctx.closePath();
    
        // Remplissage
        ctx.fillStyle = couleurRemplissage;
        ctx.fill();
    
    }



    draw(canvas, ctx)
    {
        // on commence par dessiner le cadre
        var style = getComputedStyle(document.body)
        var bordercolor = style.getPropertyValue('--default-icon-color');


        var bg = "#101010";
        if (this.status == -2) bg="black"
        
        this.dessinerRectangleArrondi(
            ctx,
            this.posX,
            this.posY,
            this.getSize().width,
            this.getSize().height,
            5,
            bg,
            bordercolor,
            2
        )

        // title

        if (this.status > 0)
            this.dessinerRectangleArrondiSansBordure(
                ctx,
                this.posX+5,
                this.posY+5,
                this.getSize().width-10,
                20,
                5,
                "#800000",
            )
        else

            if (this.status == -3)
                this.dessinerRectangleArrondiSansBordure(
                    ctx,
                    this.posX+5,
                    this.posY+5,
                    this.getSize().width-10,
                    20,
                    5,
                    "#008000",
                )

        else
            if (this.status === 0)
                this.dessinerRectangleArrondiSansBordure(
                    ctx,
                    this.posX+5,
                    this.posY+5,
                    this.getSize().width-10,
                    20,
                    5,
                    "#000080",
                )
            else

                this.dessinerRectangleArrondiSansBordure(
                        ctx,
                        this.posX+5,
                        this.posY+5,
                        this.getSize().width-10,
                        20,
                        5,
                        "#303030",
                    )


        ctx.textBaseline = "top";
        ctx.font = "15px Arial";
        ctx.fillStyle="White";
        const largeurtitle = ctx.measureText(this.title).width;

        //ctx.beginPath();
        //ctx.rect(this.posX+4, this.posY, this.posX + this.getSize().width -8, this.getSize().height); // x, y, largeur, hauteur
        //ctx.clip();

        ctx.fillText(this.title, this.posX + this.getSize().width/2 - largeurtitle/2, this.posY+7);                

        if (this.status == -3)
        {
            this.dessinerRectangleArrondi(
                ctx,
                this.posX + 8,
                this.posY + this.getSize().height - 5 - 20,
                this.getSize().width - 2 * 8,
                20,
                5,
                'black',
                bordercolor,
                1
            )

            ctx.textBaseline = "top";
            ctx.font = "12px Arial";
            ctx.fillStyle="White";
            var pc= "Terminé avec succès";
            if (this.language === "en") pc = "Done"
            const largeurpc = ctx.measureText(pc).width;
            ctx.fillText(pc, this.posX  + this.getSize().width/2 - largeurpc/2, 
                this.posY + this.getSize().height - 20);

        }


        if (this.status >0 )
            {
                this.dessinerRectangleArrondi(
                    ctx,
                    this.posX + 8,
                    this.posY + this.getSize().height - 5 - 20,
                    this.getSize().width - 2 * 8,
                    20,
                    5,
                    'black',
                    bordercolor,
                    1
                )
    
                ctx.textBaseline = "top";
                ctx.font = "12px Arial";
                ctx.fillStyle="red";
                var pc= this.error;

                ctx.save()
                ctx.beginPath();
                ctx.rect(
                    this.posX + 10,
                    this.posY + this.getSize().height - 2 - 20,
                    this.getSize().width - 2 * 8 -4,
                    13,
                )
                ctx.clip();

                
                


                ctx.fillText(pc, this.posX  + 10, 
                    this.posY + this.getSize().height - 20);
                ctx.restore()
            }
    
    


        if (this.status == -2)
            {
                this.dessinerRectangleArrondi(
                    ctx,
                    this.posX + 8,
                    this.posY + this.getSize().height - 5 - 20,
                    this.getSize().width - 2 * 8,
                    20,
                    5,
                    'black',
                    bordercolor,
                    1
                )
    
                ctx.textBaseline = "top";
                ctx.font = "12px Arial";
                ctx.fillStyle="White";
                var pc= "Non demandé";
                if (this.language === "en") pc = "None"
                const largeurpc = ctx.measureText(pc).width;
                ctx.fillText(pc, this.posX  + this.getSize().width/2 - largeurpc/2, 
                    this.posY + this.getSize().height - 20);
    
            }
    

            if (this.status == -1)
                {
                    this.dessinerRectangleArrondi(
                        ctx,
                        this.posX + 8,
                        this.posY + this.getSize().height - 5 - 20,
                        this.getSize().width - 2 * 8,
                        20,
                        5,
                        'black',
                        bordercolor,
                        1
                    )
        
                    ctx.textBaseline = "top";
                    ctx.font = "12px Arial";
                    ctx.fillStyle="White";
                    var pc= "En attente";
                    if (this.language === "en") pc = "On hold"
                    if (this.repeat !==0)
                    {
                        pc = pc + '.'.repeat(this.repeat);
                    }
                    this.repeat=this.repeat+1; if (this.repeat === 10) this.repeat=0;

                    const largeurpc = ctx.measureText(pc).width;
                    ctx.fillText(pc, this.posX  + this.getSize().width/2 - largeurpc/2, 
                        this.posY + this.getSize().height - 20);
        
                }
        
    


            if (this.status == 0) // on dessine une progressbar
        {
        
            ctx.textBaseline = "top";
            ctx.font = "12px Arial";
            ctx.fillStyle="White";

            this.dessinerRectangleArrondi(
                ctx,
                this.posX + 8,
                this.posY + this.getSize().height - 5 - 20,
                this.getSize().width - 2 * 8,
                20,
                5,
                'black',
                bordercolor,
                1
            )

            var lpc = this.getSize().width - 2 * 8 -4;
            lpc = (lpc * this.pc) / 100;
            this.dessinerRectangleArrondiSansBordure(
                ctx,
                this.posX + 10,
                this.posY + this.getSize().height - 2 - 20,
                lpc,
                13,
                5,
                "#000080",
            )
            


            ctx.textBaseline = "top";
            ctx.font = "12px Arial";
            ctx.fillStyle="White";

            var pc= this.pc.toString() + "%";
            const largeurpc = ctx.measureText(pc).width;
            ctx.fillText(pc, this.posX  + this.getSize().width/2 - largeurpc/2, 
                this.posY + this.getSize().height - 20);

        }

        
        

    }
    
}

export default BaseWorker


